export enum PAGINATION_BUTTON_VARIANT {
  ARROW = "arrow",
  TEXT = "text",
}

export enum PAGINATION_DIRECTION {
  RIGHT = "right",
  LEFT = "left",
}

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  // eslint-disable-next-line no-unused-vars
  onPageChange: (page: number) => void;
  pageItemsToShow: number;
  variant: PAGINATION_BUTTON_VARIANT;
}

export interface PaginationItemProps {
  page?: number;
  isCurrent?: boolean;
  isLast?: boolean;
  onClick?: () => void;
  dots?: boolean;
}

export interface PaginationButtonProps {
  variant: PAGINATION_BUTTON_VARIANT;
  handleChangePage: () => void;
  disable: boolean;
  text?: string;
  className: string;
  direction: PAGINATION_DIRECTION;
}
